export default __webpack_public_path__ + "static/media/arrow-up-icon-black.b2782b6b.svg";